const IPFSIcon = ({ ...props }) => (
	<svg
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M2.343 18.741C2.615 18.983 2.452 18.851 11.684 21.949C11.8891 22.0173 12.1109 22.0173 12.316 21.949C21 19 21.284 19.073 21.658 18.741C21.7743 18.6323 21.8666 18.5005 21.929 18.354C21.9739 18.2413 21.998 18.1213 22 18V6C21.998 5.87867 21.9739 5.75871 21.929 5.646C21.8666 5.49953 21.7743 5.36772 21.658 5.259C21.295 4.937 21.091 5.019 12.316 2.051C12.1109 1.98268 11.8891 1.98268 11.684 2.051C8.9 2.984 2.785 5 2.542 5.125C2.46993 5.16101 2.40272 5.20604 2.342 5.259C2.22565 5.36789 2.13305 5.49964 2.07 5.646C2.02539 5.75878 2.00167 5.87873 2 6V18C2.00199 18.1213 2.02605 18.2413 2.071 18.354C2.13382 18.5005 2.22645 18.6323 2.343 18.741ZM20 16.612L16.316 15.385C16.064 15.3012 15.7891 15.3209 15.5517 15.4398C15.3143 15.5587 15.1338 15.767 15.05 16.019C14.9662 16.271 14.9859 16.5459 15.1048 16.7833C15.2237 17.0207 15.432 17.2012 15.684 17.285L17.838 18L13 19.612V9.721L20 7.388V16.612ZM12 4.054L17.838 6L12 7.946L6.162 6L12 4.054ZM4 7.388L11 9.721V19.612L6.162 18L8.316 17.282C8.56796 17.1982 8.7763 17.0177 8.8952 16.7803C9.01409 16.5429 9.03381 16.268 8.95 16.016C8.86619 15.764 8.68573 15.5557 8.44831 15.4368C8.21089 15.3179 7.93596 15.2982 7.684 15.382L4 16.612V7.388Z"
			fill="currentColor"
		/>
	</svg>
)

export default IPFSIcon
